import nqs from 'qs';

export function getQuery() {
    const search = window.location.search;
    return nqs.parse(search, { ignoreQueryPrefix: true }) || {};
}
